import { ellipsis } from 'polished'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface CatchwordProps {
  isVideoOnly: boolean
  children: string
}

type StyledCatchwordProps = Pick<CatchwordProps, 'isVideoOnly'>

const StyledCatchword = styled.div<StyledCatchwordProps>`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: {
        grey: { grey_10, grey_80 },
      },
    },
    isVideoOnly,
  }) => {
    return css`
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      line-height: 1.1;
      font-size: 14px;

      ${ellipsis('100%', 1)};

      /*  //! Needed because "ellipsis()" returns "display: inline-block;" 
       *  //! when the second argument is 1. 
       */
      display: block;

      color: ${isVideoOnly ? grey_10 : grey_80};

      > strong {
        color: ${isVideoOnly ? grey_10 : grey_80};
        font-weight: 500;
      }

      > p {
        margin: 0;
      }
    `
  }}
`

const Catchword: FunctionComponent<CatchwordProps> = ({
  isVideoOnly,
  children,
}) => (
  <StyledCatchword
    isVideoOnly={isVideoOnly}
    dangerouslySetInnerHTML={{
      __html: children,
    }}
  />
)

export default Catchword
